
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projects-aj-cdnz-aj-6552-c-3-joax-5-ui.json") })
        }
      }, "path---projects-aj-cdnz-aj-6552-c-3-joax-5-ui");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---projects-aj-cdnz-aj-6552-c-3-joax-5-ui!./.cache/json/projects-aj-cdnz-aj-6552-c-3-joax-5-ui.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---projects-aj-cdnz-aj-6552-c-3-joax-5-ui!./.cache/json/projects-aj-cdnz-aj-6552-c-3-joax-5-ui.json
// module chunks = 15178676390636814000